// tzen-360-ui/src/UserManagement.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './css/UserManagement.css';

const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/api/users', { withCredentials: true });
      const usersWithRoles = response.data.map(u => ({
          ...u,
          currentRole: u.roles.length > 0 ? u.roles.find(r => r.name === 'admin') ? 'admin' : 'user' : 'user'
      }));
      setUsers(usersWithRoles);
    } catch (err) {
      setError('Failed to fetch users. You may not have permission.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleRoleChange = (userId, newRole) => {
    setUsers(users.map(u => u._id === userId ? { ...u, currentRole: newRole } : u));
  };

  const handleUpdateUser = async (userId, newRole) => {
    if (!window.confirm("Are you sure you want to change this user's role?")) return;
    try {
      await axios.put(`/api/users/${userId}`, { roles: [newRole] }, { withCredentials: true });
      alert('User role updated successfully.');
      fetchUsers();
    } catch (err) {
      alert('Failed to update user role.');
    }
  };

  const handleDeleteUser = async (userId) => {
    if (!window.confirm("Are you sure you want to permanently delete this user? This cannot be undone.")) return;
    try {
      await axios.delete(`/api/users/${userId}`, { withCredentials: true });
      alert('User deleted successfully.');
      setUsers(users.filter(u => u._id !== userId));
    } catch (err) {
      alert('Failed to delete user.');
    }
  };

  if (loading) return <div>Loading users...</div>;
  if (error) return <div className="error-message">{error}</div>;

  return (
    <div className="user-management-container">
      <h2>User Management</h2>
      <table className="user-table">
        <thead>
          <tr>
            <th>Username</th>
            <th>Email</th>
            <th>Role</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map(user => (
            <tr key={user._id}>
              <td>{user.username}</td>
              <td>{user.email}</td>
              <td>
                <select 
                  value={user.currentRole} 
                  onChange={(e) => handleRoleChange(user._id, e.target.value)}
                >
                  <option value="user">User</option>
                  <option value="admin">Admin</option>
                </select>
              </td>
              <td className="actions-cell">
                <button 
                  className="save-btn" 
                  onClick={() => handleUpdateUser(user._id, user.currentRole)}
                >
                  Save
                </button>
                <button 
                  className="delete-btn" 
                  onClick={() => handleDeleteUser(user._id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UserManagement;